import { render } from "./TheTwoColumnsLayout.vue?vue&type=template&id=1587a562"
import script from "./TheTwoColumnsLayout.vue?vue&type=script&lang=js"
export * from "./TheTwoColumnsLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__